import { render, staticRenderFns } from "./HistoricoDisperso.vue?vue&type=template&id=7aa5fd90&"
import script from "./HistoricoDisperso.vue?vue&type=script&lang=js&"
export * from "./HistoricoDisperso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports